/* Labels hard-coded Twist prices ($129 / $159) with the visitor's own currency, using the live product prices. */
(function () {
  var RE = /\$(129|159)(?![\d.]|\s?(USD|CAD))/g;
  var HANDLE = { '129': 'the-twist', '159': 'the-twist-heirloom' };
  function fmt(cents, cur) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? String(v) : v.toFixed(2)) + ' ' + cur;
  }
  function run() {
    try {
      var main = document.getElementById('MainContent');
      var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      if (!main || !cur) return;
      RE.lastIndex = 0;
      if (!RE.test(main.textContent)) return;
      var prices = {};
      Promise.all(['129', '159'].map(function (k) {
        return fetch('/products/' + HANDLE[k] + '.js').then(function (r) { return r.json(); }).then(function (p) { prices[k] = fmt(p.price, cur); });
      })).then(function () {
        var w = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
        var nodes = [], n;
        while ((n = w.nextNode())) { RE.lastIndex = 0; if (RE.test(n.nodeValue)) nodes.push(n); }
        nodes.forEach(function (t) { t.nodeValue = t.nodeValue.replace(RE, function (m, k) { return prices[k] || m; }); });
      }).catch(function () {});
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
